import { usePitcher } from "features/utils/usePitcher";
import { useEffect, useState } from "react";

export const usePermissions = () => {
  // We want this hook to reconcile whenever Pitcher reconnects as the capabilities might have updated
  const [_, setState] = useState(0);
  const pitcher = usePitcher();

  useEffect(() => {
    const disposable = pitcher.onReconnected(() => setState((c) => c + 1));
    return () => disposable.dispose();
  }, [pitcher]);

  return pitcher.permissions;
};
